import React from 'react';


// Prime React Components
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { RadioButton } from 'primereact/radiobutton';

const FileTypeChooser = (props) => {
	const { onInputChange, entity, fileUploadRef, fileName, radioName, inputName, currentName, filePath } = props

	const fileHeaderTemplate = (options) => {
        const { className, chooseButton } = options;
        return (
            <div className={className + ' flex justify-content-between'} style={{ backgroundColor: 'transparent', alignItems: 'center' }}>
                <div>
					{chooseButton}
				</div>
				{entity[currentName] && entity[currentName] !== "" && entity[radioName] === 'file' && 
					<div className="flex flex-column">
						<div className="eventMessage">
							Current
						</div>
						{filePath && 
							<div>
								<a href={filePath + entity[currentName]} target="_blank" rel="noopener noreferrer">
									{entity[currentName]} 
								</a>
							</div>
						}
						{!filePath && 
							<div>
								{entity[currentName]} 
							</div>
						}
					</div>
				}
            </div>
        );
    };
    
    return (
        
									
		<div className="flex flex-column" style={{width:'100%'}}>
			<div className="flex align-items-center pb-2">
				<div>
					<RadioButton inputId="fileType1" name="file" value="file" onChange={(e) => onInputChange(e.value,radioName)} checked={entity[radioName] === 'file'} />
				</div>
				<div className="mr-4">
					<label htmlFor="fileType1" className="ml-2">File</label>
				</div>
				<div style={{width: "100%"}}>
					<FileUpload 
						name={fileName}
						ref={fileUploadRef} 
						disabled={entity[radioName] === 'url'}
						accept="application/pdf" 
						maxFileSize={10000000} 
						headerTemplate={fileHeaderTemplate}
						emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>} />
				</div>
			</div>
			<div className="flex align-items-center pb-2">
				<div>
					<RadioButton inputId="fileType2" name="url" value="url" onChange={(e) => onInputChange(e.value,radioName)} checked={entity[radioName] === 'url'} />
				</div>
				<div className="mr-4">
					<label htmlFor="fileType2" className="ml-2">URL</label>
				</div>
				<div style={{width: "100%"}}>
					<InputText id="name" 
						value={entity[inputName]} 
						onChange={(e) => onInputChange(e.target.value, inputName)} 
						disabled={entity[radioName] === 'file'} />
				</div>
				
			</div>
		</div>						
    );
}

export default FileTypeChooser;